import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import ParticleBackground from './components/ParticleBackground';
import CursorTrail from './components/CursorTrail';
import Header from './components/Header';
import Hero from './components/Hero';
import BlogPosts from './components/BlogPosts';
import Skills from './components/Skills';
import Footer from './components/Footer';
import './css/App.css';
import './css/theme.css';
import './css/header.css';
import './css/blog.css';
import './css/skills.css';

function App() {
  return (
    <ThemeProvider>
      <ParticleBackground />
      <CursorTrail />
      <div className='app'>
        <Header />
        <Hero />
        <Skills />
        <BlogPosts />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
